export var ClassificationFlow;
(function (ClassificationFlow) {
    ClassificationFlow["EU"] = "eu";
    ClassificationFlow["US"] = "us";
    ClassificationFlow["UK"] = "uk";
})(ClassificationFlow || (ClassificationFlow = {}));
export var LpInvestorClassificationStage;
(function (LpInvestorClassificationStage) {
    LpInvestorClassificationStage["EULegalEntityCategorisation"] = "eu-legal-entity-categorisation";
    LpInvestorClassificationStage["EULegalEntityExperience"] = "eu-legal-entity-experience";
    LpInvestorClassificationStage["EULegalEntityKnowledge"] = "eu-legal-entity-knowledge";
    LpInvestorClassificationStage["UKLegalEntityCategorisation"] = "uk-legal-entity-categorisation";
    LpInvestorClassificationStage["UKLegalEntityWarning"] = "uk-legal-entity-warning";
    LpInvestorClassificationStage["UKLegalEntityExperience"] = "uk-legal-entity-experience";
    LpInvestorClassificationStage["UKLegalEntityKnowledge"] = "uk-legal-entity-knowledge";
    LpInvestorClassificationStage["USLegalEntityAccreditedInvestor"] = "us-legal-entity-accredited-investor";
    LpInvestorClassificationStage["USLegalEntityQualifiedPurchaser"] = "us-legal-entity-qualified-purchaser";
    LpInvestorClassificationStage["USLegalEntityQualifiedClient"] = "us-legal-entity-qualified-client";
    LpInvestorClassificationStage["USLegalEntityExperience"] = "us-legal-entity-experience";
    LpInvestorClassificationStage["USLegalEntityKnowledge"] = "us-legal-entity-knowledge";
    LpInvestorClassificationStage["EUIndividualExperience"] = "eu-individual-experience";
    LpInvestorClassificationStage["EUIndividualKnowledge"] = "eu-individual-knowledge";
    LpInvestorClassificationStage["UKIndividualSophisticatedInvestorStatement"] = "uk-individual-sophisticated-investor-statement";
    LpInvestorClassificationStage["UKIndividualHighNetWorthInvestorStatement"] = "uk-individual-high-net-worth-investor-statement";
    LpInvestorClassificationStage["UKIndividualProfessionalClientStatement"] = "uk-individual-professional-client-statement";
    LpInvestorClassificationStage["UKIndividualExperience"] = "uk-individual-experience";
    LpInvestorClassificationStage["UKIndividualKnowledge"] = "uk-individual-knowledge";
    LpInvestorClassificationStage["USIndividualAccreditedInvestor"] = "us-individual-accredited-investor";
    LpInvestorClassificationStage["USIndividualQualifiedPurchaser"] = "us-individual-qualified-purchaser";
    LpInvestorClassificationStage["USIndividualQualifiedClient"] = "us-individual-qualified-client";
    LpInvestorClassificationStage["USIndividualExperience"] = "us-individual-experience";
    LpInvestorClassificationStage["USIndividualKnowledge"] = "us-individual-knowledge";
})(LpInvestorClassificationStage || (LpInvestorClassificationStage = {}));
export var LpInvestorClassification;
(function (LpInvestorClassification) {
    LpInvestorClassification["UKHighNetWorthInvestor"] = "uk-high-net-worth-investor";
    LpInvestorClassification["UKSophisticatedInvestor"] = "uk-sophisticated-investor";
    LpInvestorClassification["UKProfessionalClient"] = "uk-professional-client";
    LpInvestorClassification["EUElectiveProfessionalClient"] = "eu-elective-professional-client";
    LpInvestorClassification["USAccreditedInvestor"] = "us-accredited-investor";
    LpInvestorClassification["USQualifiedPurchaser"] = "us-qualified-purchaser";
    LpInvestorClassification["USQualifiedClient"] = "us-qualified-client";
})(LpInvestorClassification || (LpInvestorClassification = {}));
//# sourceMappingURL=index.js.map